import React from 'react'
import {Link, withRouter} from 'react-router-dom'
import {Button, Label, Media, Row} from 'reactstrap'
import {AvFeedback, AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation'
import {authenticationHelpers} from "../../../dataHelpers"
import SFLogo from '../../../images/sf-logo-horizontal.png'
import {pageHelpers} from '../'
import '../../../stylesheets/Authentication.css'
import '../../../stylesheets/Animations.css'

class LogInPage extends React.Component {
    constructor(props) {
        super(props)

        const {onComplete} = props
        this.onComplete = onComplete
        pageHelpers.setupPropsForPage(props, this)

        this.state = {
            errors: [],
            isFirstLogIn: authenticationHelpers.isFirstLogIn(),
            passwordReset: this.queryParams.pwr
        }

        this.initialFormValues = {
            stayLoggedIn: true
        }

        this.handleValidSubmit = this.handleValidSubmit.bind(this)
    }

    componentWillMount() {
        pageHelpers.setupSingleRunAnimationEvents()
    }

    componentWillUnmount() {
        pageHelpers.tearDownSingleRunAnimationEvents()
    }

    componentWillReceiveProps(nextProps) {
        const {onComplete} = nextProps
        this.onComplete = onComplete
        pageHelpers.setupPropsForPage(nextProps, this)

        this.setState({
            stayLoggedIn: true,
            passwordReset: this.queryParams.pwr,
            isFirstLogIn: authenticationHelpers.isFirstLogIn()
        })
    }

    async handleValidSubmit(event, values) {
        event.preventDefault()
        let {email, password, stayLoggedIn} = values
        let redirectTo = (this.location.state ? this.location.state.from.pathname : '/')
        let authResponse = await authenticationHelpers.logIn(email, password, stayLoggedIn, redirectTo, this.history)

        if (authResponse.token) {
            let token = authResponse.token
            let user = await authenticationHelpers.loadUser(token)
            authenticationHelpers.clearFirstLogInFlag()
            await this.onComplete(user, authResponse.token)
        } else if (authResponse.error) {
            this.setState({errors: [authResponse.error]})
        }
    }

    render() {
        let {isFirstLogIn, passwordReset, errors} = this.state

        return <Row className="justify-content-center">
            <AvForm onValidSubmit={this.handleValidSubmit}
                    onInvalidSubmit={pageHelpers.handleInvalidFormSubmit}
                    model={this.initialFormValues}
                    className="col-md-6 col-sm-10 text-left">
                <div className="text-center">
                    <Media object className="col-10 mb-4" src={SFLogo} alt="SureFire Ag Logo"/>
                    {(isFirstLogIn ?
                        <h2 className="mb-4">
                            Your <strong>Marksman</strong> account has been activated. <br/> Please Sign In.
                        </h2> :
                        (passwordReset ?
                            <h2 className="mb-4">Your Password has been reset. <br/> Please Sign In.</h2> :
                            <h2 className="mb-4">Sign in to your <strong>Marksman</strong> account</h2>))}
                </div>
                <AvGroup>
                    <Label for="email">Email Address</Label>
                    <AvInput type="email"
                              name="email"
                              placeholder="you@email.com"
                              autoComplete="email"
                              required/>
                    <AvFeedback>Please enter a valid email address.</AvFeedback>
                </AvGroup>
                <AvGroup>
                    <Label for="password">Password</Label>
                    <AvInput type="password"
                              name="password"
                              placeholder="********"
                              autoComplete="current-password"
                              required/>
                    <AvFeedback>Please enter a valid password address.</AvFeedback>
                </AvGroup>
                <AvGroup check>
                    <Label className="col-6" check>
                        <AvInput type="checkbox" name="stayLoggedIn"/> Remember&nbsp;Me
                    </Label>
                    <Button className="col-4 offset-2">Log In</Button>
                </AvGroup>
            </AvForm>

            <Link className="text-muted col-12 pt-4 pb-4 text-center" to="/forgot">Forgot Your Password?</Link>
            {pageHelpers.renderErrorModalsForPage(errors, this)}
        </Row>
    }
}

export default withRouter(LogInPage)



// WEBPACK FOOTER //
// ./src/components/pages/authentication/LogInPage.js